var _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaudiArabia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#6da544",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m144.696 306.087c0 18.441 14.95 33.391 33.391 33.391h100.174c0 15.368 12.458 27.826 27.826 27.826h33.391c15.368 0 27.826-12.458 27.826-27.826v-33.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.087 144.696v77.913c0 12.275-9.986 22.261-22.261 22.261v33.391c30.687 0 55.652-24.966 55.652-55.652v-77.913z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.783 222.609c0 12.275-9.986 22.261-22.261 22.261v33.391c30.687 0 55.652-24.966 55.652-55.652v-77.913h-33.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 144.696h33.391v77.913h-33.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.913 189.217c0 3.069-2.497 5.565-5.565 5.565s-5.565-2.497-5.565-5.565v-44.522h-33.391v44.522c0 3.069-2.497 5.565-5.565 5.565s-5.565-2.497-5.565-5.565v-44.522h-33.392v44.522c0 21.481 17.476 38.957 38.957 38.957 8.273 0 15.945-2.6 22.261-7.016 6.315 4.415 13.988 7.016 22.261 7.016 1.666 0 3.304-.117 4.915-.322-2.366 9.749-11.146 17.017-21.611 17.017v33.391c30.687 0 55.652-24.966 55.652-55.652v-33.391-44.522h-33.391v44.522z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.87 244.87h50.087v33.391h-50.087z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiArabia);
export default __webpack_public_path__ + "static/media/saudiArabia.1fd7d56e9b8780f10936bddae2d1afb2.svg";
export { ForwardRef as ReactComponent };